function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

// Variable to track the disconnected state
var observerDisconnected = false;

// Function to update the checkbox and SVGs
function updateCookieConsentPreferences() {
  var $marketingCheckbox = $('#shopify-pc__prefs__marketing-input');
  var $analyticsCheckbox = $('#shopify-pc__prefs__analytics-input'); // Adjust if needed
  var $personalizationCheckbox = $('#shopify-pc__prefs__preferences-input'); // Personalization checkbox

  if ($marketingCheckbox.length) {
    $marketingCheckbox.prop('checked', true);
    $marketingCheckbox.closest('label').find('svg[data-icon-type="checked"]').css('display', 'block');
    $marketingCheckbox.closest('label').find('svg[data-icon-type="unchecked"]').css('display', 'none');
  }
  if ($analyticsCheckbox.length) {
    $analyticsCheckbox.prop('checked', true);
    $analyticsCheckbox.closest('label').find('svg[data-icon-type="checked"]').css('display', 'block');
    $analyticsCheckbox.closest('label').find('svg[data-icon-type="unchecked"]').css('display', 'none');
  }
  if ($personalizationCheckbox.length) {
    $personalizationCheckbox.prop('checked', true);
    $personalizationCheckbox.closest('label').find('svg[data-icon-type="checked"]').css('display', 'block');
    $personalizationCheckbox.closest('label').find('svg[data-icon-type="unchecked"]').css('display', 'none');
  }
}

// Observe for the modal to appear
var observer = new MutationObserver(function(mutationsList, observer) {
  if ($('#shopify-pc__prefs__dialog').length > 0) {
    updateCookieConsentPreferences();
  }
});

// Observe the body for changes (e.g., the appearance of the cookie consent modal)
observer.observe(document.body, { childList: true, subtree: true });

$(document).on('click', '#shopify-pc__banner__btn-accept', function() {
  observer.disconnect();
  observerDisconnected = true;
});

$(document).on('click', '#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-save', function() {
  observer.disconnect();
  observerDisconnected = true;
});


function checkCookieStatus() {
  var cookieValue = getCookie('_tracking_consent');

  if (cookieValue) {
    var decodedValue = decodeURIComponent(cookieValue);

    // Disconnect observer if cookie exists
    if (!observerDisconnected) {
      observer.disconnect();
      observerDisconnected = true;
    }

    // console.log('Cookie _tracking_consent is present:', decodedValue);
  } else {
    console.log('Cookie _tracking_consent not found.');
  }
}



$(document).ready(function(){
  checkCookieStatus();
})
